var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('empty-view',[_c('template',{slot:"img"},[_c('img',{attrs:{"src":require("@/assets/error@2x.png"),"width":"90"}})]),_vm._v("\n  Oops! Something went wrong."),_c('br'),_vm._v("\n  Please try again later.\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }